// CORE
import { Form } from '@autoprog/core-client';

// NODE_MODULE
import { Moment } from 'moment';
import _ from 'lodash';

// TEMPLATE
import T_modal from '../../../tpl/modals/editPage/dates.html';

// LIBS
import DeadlinePaymentUtils from '@libs/utils/DeadlinePaymentUtils';
import Modal from '@libs/Modal';

// TYPES
import { DeadlinePayment } from '@js/types/_app/deadlinePayment';
import { Relaunch } from '@js/types/_app/relaunch';

// CUSTOM_ELEMENT
import CE_Select2 from '@libs/customElement/Select2';

type DatesData = {
	infos: {
		date: Moment,
		datePayment: Moment,
		sendDate: Moment,
		number: string
	},
	deadlinePayment: DeadlinePayment,
	relaunch: Pick<Relaunch, 'date'>
};

class Dates extends Modal {
	private selectPostinit: { [key: string]: CE_Select2 } = {};

	private form: Form | null;

	private oldData: DatesData;

	constructor(data: DatesData) {
		super({
			tpl: T_modal,
			keyboard: false,
			backdrop: 'static'
		});

		this.form = null;
		this.oldData = data;

		this.on('opened', async () => {
			this.form = new Form(this.element.querySelector('form') as HTMLFormElement);

			await this.setData(this.oldData);

			this.initEvents();
			this.postInit();

			const N_save = this.element.querySelector('#save') as HTMLButtonElement;

			N_save.addEventListener('click', async () => {
				N_save.loading(new Promise(async () => {
					const res = _.merge(this.oldData, this.form?.getData());
					this.resolve(res);
				}));
			});

			this.updateButtonSave();
		});
	}

	private initEvents() {
		const N_date = this.element.querySelector('[name="infos.date"]') as HTMLInputElement;
		const N_datePayment = this.element.querySelector('[name="infos.datePayment"]') as HTMLInputElement;
		const N_sendDate = this.element.querySelector('[name="infos.sendDate"]') as HTMLInputElement;

		N_date.addEventListener('change', async () => {
			const date = this.form?.getDataByName('infos.date') as Moment;

			if (date) {
				const paidDate = DeadlinePaymentUtils.calculateDate(date, this.oldData.deadlinePayment.day, this.oldData.deadlinePayment.fixedDate, this.oldData.deadlinePayment.type);

				const tmp: { [key: string]: any } = {
					infos: {}
				};

				const oldNumber = this.oldData.infos.number;

				if (oldNumber) {
					const number = (this.oldData.infos.number || '').replace('FC-', '').split('-');
					tmp.infos.number = `FC-${date.format('YYYY-MM')}-${number.slice(2).join('-')}`;
				}

				if (this.oldData.deadlinePayment.type !== '3') {
					tmp.infos.datePayment = paidDate.clone();
					tmp.relaunch = {
						date: paidDate.clone().add(1, 'week')
					};
				}

				this.oldData = _.merge(this.oldData, tmp);

				this.form?.setData(tmp);
			}

			this.updateButtonSave();
		});

		N_datePayment.addEventListener('change', () => {
			const datePayment = this.form?.getDataByName('infos.datePayment') as Moment;

			this.oldData.relaunch.date = datePayment.clone().add(1, 'week');

			this.updateButtonSave();
		});

		N_sendDate.addEventListener('change', async () => {
			const sendDate = this.form?.getDataByName('infos.sendDate') as Moment;

			if (sendDate && this.oldData.deadlinePayment.type === '3') {
				const paidDate = DeadlinePaymentUtils.calculateDate(sendDate, this.oldData.deadlinePayment.day, this.oldData.deadlinePayment.fixedDate, this.oldData.deadlinePayment.type);

				const tmp: { [key: string]: any } = {
					infos: {
						datePayment: paidDate.clone()
					},
					relunch: {
						date: paidDate.clone().add(1, 'week')
					}
				};

				this.oldData = _.merge(this.oldData, tmp);

				this.form?.setData(tmp);
			}

			this.updateButtonSave();
		});
	}

	private async setData(data: DatesData) {
		const res: { [key: string]: any } = {
			infos: {
				date: data.infos.date,
				datePayment: data.infos.datePayment,
				sendDate: data.infos.sendDate,
				number: data.infos.number
			},
			deadlinePayment: {
				day: data.deadlinePayment.day,
				type: data.deadlinePayment.type,
				fixedDate: data.deadlinePayment.fixedDate
			},
			relaunch: {
				date: data.relaunch.date
			}
		};

		this.form?.setData(res);
	}

	private updateButtonSave() {
		const N_save = this.element.querySelector('#save') as HTMLButtonElement;

		const date = this.form?.getDataByName('infos.date') as Moment;
		const datePayment = this.form?.getDataByName('infos.datePayment') as Moment;

		N_save.disabled = !date || !datePayment;
	}

	private postInit() {
		for (const key in this.selectPostinit) {
			this.selectPostinit[key].postInit();
		}
	}
}

export default Dates;
